import { render, staticRenderFns } from "./editcalendar.vue?vue&type=template&id=22d63bcc&scoped=true&"
import script from "./editcalendar.vue?vue&type=script&lang=js&"
export * from "./editcalendar.vue?vue&type=script&lang=js&"
import style0 from "./editcalendar.vue?vue&type=style&index=0&id=22d63bcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d63bcc",
  null
  
)

export default component.exports